import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_80: FaireProductEntity = {
  token: "legacy_prod_abbott-80",
  type: "product",
  name: "Large We Care Dancing Bees Napkins, 20 Pack",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/3ddaad0f96d45cf5e02965ca3f0ff75d46f99e6986712828daa808c5da1531da.jpeg",
  priceDollars: 12,
  subcategory: "Tableware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_party-supplies"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
